
import {Component, Vue, Prop} from 'vue-property-decorator';
import aiConfigList from '@/js/aiConfig/aiconfig-list.helper';
import {AIMonitorApi} from '@/api';
import moment from 'moment';

@Component
export default class CapacityUsage extends Vue {
    @Prop({default: () => []}) schoolParams!: Array<string>;
    aiConfigItem = aiConfigList.aiConfigItem;
    dataList = [];
    configStatus = '';
    getAIUsage(ruleList: any, ruleId: string) {
        const list = ruleList.filter((item: {_id: string}) => item._id === ruleId)[0];
        const exhausted: any = this.waringSchoolList.find((e: {schoolId: string}) => e.schoolId === this.schoolParams[0]);
        this.configStatus = list.status;
        this.dataList = this.aiConfigItem.map((item: {value: string | number; label: any}) => {
            const countObj =
                exhausted && exhausted.exhausted.length
                    ? exhausted.exhausted.find((e: {type: string | number}) => e.type === item.value)
                    : 0;
            return {
                key: item.value,
                name: item.label,
                max: list.overview[item.value]?.max || 0,
                used: list.used[item.value] || 0,
                usedRate: list.overview[item.value]?.max
                    ? Math.floor((list.used[item.value] / list.overview[item.value]?.max) * 10000) / 100
                    : 0,
                iconSrc: require(`@/assets/image/aiIcon-${item.value}.svg`),
                count: countObj ? countObj.count : 0
            };
        });
    }

    waringSchoolList = [];
    getWarningData(ruleList: any, ruleId: string) {
        AIMonitorApi.getSystemWarn({
            context: this,
            success: (data: any) => {
                if (data.code === 0) {
                    this.waringSchoolList = data.data;
                    this.getAIUsage(ruleList, ruleId);
                }
            }
        });
    }
    formatTime(time: number) {
        const days = moment.duration(time).days() ? moment.duration(time).days() : 0;
        const hour = moment.duration(time).hours() ? days * 24 + moment.duration(time).hours() + '时' : '';
        const min = moment.duration(time).minutes() ? moment.duration(time).minutes() + '分' : '';
        const second = moment.duration(time).seconds() ? moment.duration(time).seconds() + '秒' : '';
        return hour + min + second ? hour + min + second : 0;
    }
}
